import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getFont } from '@finect/tabular-utils/getFont';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-x5t5jt-0"
})(["display:flex;flex-direction:column;justify-content:space-between;height:100%;"]);
export var OrganizationLogoBlock = styled(AppLink).withConfig({
  displayName: "partials__OrganizationLogoBlock",
  componentId: "sc-x5t5jt-1"
})(["display:block;", " padding:24px 0;height:178px;img{max-width:280px;vertical-align:middle;}", ""], function (_ref) {
  var theme = _ref.theme,
    $withBackground = _ref.$withBackground;
  return $withBackground && "background-color: ".concat(theme.colors.accent1LL, ";");
}, minMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 196px;\n  \n  img {\n      max-width: 320px;\n    }\n  "]))));
export var HeaderBlock = styled.div.withConfig({
  displayName: "partials__HeaderBlock",
  componentId: "sc-x5t5jt-2"
})(["margin-bottom:40px;text-align:center;"]);
export var ManagerBlock = styled.div.withConfig({
  displayName: "partials__ManagerBlock",
  componentId: "sc-x5t5jt-3"
})(["", " ", ""], getFont(-1, 'compact'), minMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n    height: 168px;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n    margin-bottom: 24px;\n  "])), getFont(0, 'compact')));
export var FooterBlock = styled.div.withConfig({
  displayName: "partials__FooterBlock",
  componentId: "sc-x5t5jt-4"
})(["a{svg{vertical-align:middle;}}"]);
export var DescriptionBlock = styled.div.withConfig({
  displayName: "partials__DescriptionBlock",
  componentId: "sc-x5t5jt-5"
})(["display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:8;white-space:pre-wrap;a{display:block;text-align:center;}img{height:144px;margin-bottom:12px;}", ""], maxMediaQueries.tablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    img {\n      height: 96px;\n      margin-bottom: 12px;\n    }\n  "]))));
export var LastContentBlock = styled.div.withConfig({
  displayName: "partials__LastContentBlock",
  componentId: "sc-x5t5jt-6"
})(["display:inherit;padding-bottom:16px;& > *{padding-bottom:24px;&:first-of-type{margin-top:0;}&:last-of-type{padding-bottom:0;}}svg{width:24px;height:24px;color:", ";}", " ", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, minMediaQueries.tablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    min-height: 144px;\n    padding-bottom: 0;\n  "]))), maxMediaQueries.phone(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    margin-top: 36px;\n  "]))));
export var StyledTextContainer = styled.div.withConfig({
  displayName: "partials__StyledTextContainer",
  componentId: "sc-x5t5jt-7"
})(["overflow:hidden;"]);
export var StyledLink = styled(AppLink).withConfig({
  displayName: "partials__StyledLink",
  componentId: "sc-x5t5jt-8"
})(["display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:3;white-space:pre-wrap;"]);